<template>
  <div>
    <PopupAnonymizeVenueGuests category="sm" ref="popupAnonymizeVenueGuests" @onCancelled="onCancelAnonymization"
      @onConfirmed="onAcceptAnonymization" />

    <vx-card no-shadow>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-2/5 w-full">
          <h2>Danger Zone</h2>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="hasPermissionForActiveVenue('vp.vp.venueinfo.anonymizeguests')">
        <div class=" vx-col sm:w-1/5 w-full">
          <span>Permanently Anonymize all guests for venue. Only available if venue is closed.</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-button color="danger" @click="confirmDelete" class="ml-auto mt-2">Anonymize guests</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PopupAnonymizeVenueGuests from "./PopupAnonymizeVenueGuests.vue";
export default {
  components: {
    PopupAnonymizeVenueGuests
  },

  data() {
    return { loading: false, };
  },
  computed: {
    ...mapGetters({
      generalInfo: "venues/generalInfo",
      activeVenue: "venues/activeVenue",
    }),
  },
  methods: {
    async confirmDelete() {
      await this.$store.dispatch("venues/getGeneralInfo");
      if (this.generalInfo.status !== 1) {
        this.$vs.dialog({
          type: "alert",
          color: "primary",
          title: `Venue not closed`,
          text: `Anonymization of guests is only available for closed venues.`,
          accepText: "OK",
        });
        return;
      }

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: `Are you sure you want to permanently anonymize all guests for this venue '${this.generalInfo.name}'? This action cannot be undone. There is an additional confirmation step.`,
        acceptText: "Proceed",
        accept: this.$refs.popupAnonymizeVenueGuests.show,
        cancel: this.onCancelAnonymization,

      });
    },
    onCancelAnonymization() {
      this.$vs.dialog({
        type: "alert",
        color: "primary",
        title: `Cancelled`,
        text: `Anonymization of guests for venue '${this.generalInfo.name}' has been cancelled.`,
        acceptText: "OK",
      });
    },
    async onAcceptAnonymization() {
      this.$vs.dialog({
        type: "alert",
        color: "danger",
        title: `Venue guests anonymization has started`,
        text: `The anonymization process has started for venue '${this.generalInfo.name}'. This process may take some time.`,
        acceptText: "OK",
      });
      try {
        await this.$store.dispatch("userProfiles/anonymizeUsersForVenue", { venueId: this.activeVenue.venueId });
        this.$vs.notify({
          color: "green",
          title: "Venue users anonymized",
          text: "Successfully anonymized venue guests"
        });
      } catch (err) {
        console.log("Error anonymizing venue guests", err);
        this.$vs.notify({
          color: "danger",
          title: "Could not anonymize",
          text: "Error anonymizing venue guests"
        });
      }

    }
  },
  async mounted() {
    this.loading = true;
    // await this.$store.dispatch("venues/getContactUsers");
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.con-chips--remove-all {
  display: none;
}
</style>